import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react'

import {
  PatientChartPageContext,
  PatientChartPageContextInterface,
} from '../../../providers/PatientChartPage/PatientChartPage.provider'
import {
  SubstanceCounterContext,
  SubstanceCounterContextInterface,
} from '../../../providers/SubstanceCounter/SubstanceCounter.Provider'
import { themeColors } from '../../../theme'
import { Modal } from '../../Modal/Modal'
import { useStyles } from '../PatientChartPage.styles'

interface DiscontinueTrackedSubstanceModalInterface {
  routedPatientId: string | undefined
  showDiscontinueModal: boolean
  setShowDiscontinueModal: React.Dispatch<React.SetStateAction<boolean>>
  trackedSubstanceDiscontinueId: number
}

export const DiscontinueTrackedSubstanceModal = ({
  routedPatientId,
  showDiscontinueModal,
  setShowDiscontinueModal,
  trackedSubstanceDiscontinueId,
}: DiscontinueTrackedSubstanceModalInterface) => {
  const { classes } = useStyles()

  const {
    discontinueTrackedSubstance,
    getPatientTrackedSubstancesForProvider,
  } = useContext(SubstanceCounterContext) as SubstanceCounterContextInterface

  const { activeChartPatient, getPatientDetails } = useContext(
    PatientChartPageContext
  ) as PatientChartPageContextInterface

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (routedPatientId) {
      getPatientDetails(parseInt(routedPatientId))
    }
  }, [showDiscontinueModal])

  const handleDiscontinue = async () => {
    setLoading(true)

    if (routedPatientId) {
      await discontinueTrackedSubstance({
        patientId: parseInt(routedPatientId),
        trackedSubstanceId: trackedSubstanceDiscontinueId,
      })
      await getPatientTrackedSubstancesForProvider(parseInt(routedPatientId))
    }
    setLoading(false)
    setShowDiscontinueModal(false)
  }

  const handleCancel = () => {
    setShowDiscontinueModal(false)
  }

  return (
    <Modal
      open={showDiscontinueModal}
      setOpen={setShowDiscontinueModal}
      title={'Discontinue Tracked Substance'}
      width={'40%'}
      ModalContent={
        <Box
          sx={{
            width: '92%',
            margin: 'auto',
            padding: '10px 0',
          }}
        >
          <Typography
            sx={{
              fontSize: '20px',
              lineHeight: '25px',
              color: themeColors.grayblack,
              padding: '10px 0 20px 0',
            }}
          >
            Are you sure to discontinue this tracked substance for patient{' '}
            {activeChartPatient.patientName} (MRN#{activeChartPatient.mrn})?
          </Typography>

          <div className={classes.modalBtnWrapper}>
            <Button
              onClick={handleDiscontinue}
              variant='contained'
              disabled={loading}
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '180px',
                borderColor: 'transparent',
              }}
            >
              {loading ? (
                <CircularProgress size={20} color='primary' />
              ) : (
                'Discontinue'
              )}
            </Button>

            <Button
              onClick={handleCancel}
              variant='contained'
              style={{
                fontSize: '16px',
                marginTop: '10px',
                width: '80px',
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      }
    />
  )
}
